import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import Select from "react-select";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";

const Table5 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [importPath, setImportPath] = useState(null);
  const [PowerbiData, setPowerbiData] = useState(null);
  const [departmentList, setDepartment] = useState(null);
  const [businesseList, setBusinesse] = useState(null);
  const [levelList, setLevel] = useState(null);
  const [mainActivityList, setMainActivity] = useState(null);
  const [mainFieldList, setMainField] = useState(null);
  const [subfieldList, setSubfield] = useState(null);
  const [occupationList, setOccupation] = useState(null);
  const [organizationList, setOrganization] = useState(null);
  const [standardList, setStandard] = useState(null);
  const [masterprovince, setMasterprovince] = useState(null);

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) => {
      const data = { ...item };
      data.yearId = props.yearId;
      delete data.id;
      delete data.createDate;
      delete data.lastUpdate;
      delete data.tableHeadId;
      delete data.id;
      obj.push(data);
    });

    let filter = [];
    if (props.tableTabSettingId == 9) {
      filter = obj.filter(
        (item) =>
          item.notPassTotal === "" ||
          item.notPassTotal == null ||
          item.numberTotal === "" ||
          item.numberTotal == null ||
          item.passTotal === "" ||
          item.passTotal == null
      );
    } else {
      filter = obj.filter(
        (item) =>
          item.notPassFemale === "" ||
          item.notPassFemale == null ||
          item.notPassMale === "" ||
          item.notPassMale == null ||
          item.notPassTotal === "" ||
          item.notPassTotal == null ||
          item.numberFemale === "" ||
          item.numberFemale == null ||
          item.numberMale === "" ||
          item.numberMale == null ||
          item.numberTotal === "" ||
          item.numberTotal == null ||
          item.passFemale === "" ||
          item.passFemale == null ||
          item.passMale === "" ||
          item.passMale == null ||
          item.passTotal === "" ||
          item.passTotal == null
      );
    }

    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ? null : Number(props.yearNo),
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        if (response.data.data.length > 0) {
          setImportPath(response.data.data[0].importPath);
          if (response.data.data[0].list.length == 0) {
            getNewData();
          } else {
            const dataView = response.data.data[0].list.map((item) => {
              let data = { ...item };
              if (props.type === "new" && props.newHeadId) {
                if (response.data.data[0].yearId != props.yearId) {
                  data.notPassFemale = "";
                  data.notPassMale = "";
                  data.notPassTotal = "";
                  data.numberFemale = "";
                  data.numberMale = "";
                  data.numberTotal = "";
                  data.passFemale = "";
                  data.passMale = "";
                  data.passTotal = "";
                }
              }
              return data;
            });
            setLoading(false);
            if (
              props.type == "new" &&
              response.data.data[0].yearId != props.yearId
            ) {
              const dataNew = [...dataView];
              setPowerbiData([dataNew[0]]);
            } else {
              setPowerbiData(dataView);
            }
          }
        } else {
          setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
            if (props.type === "new" && props.newHeadId) {
              data.notPassFemale = "";
              data.notPassMale = "";
              data.notPassTotal = "";
              data.numberFemale = "";
              data.numberMale = "";
              data.numberTotal = "";
              data.passFemale = "";
              data.passMale = "";
              data.passTotal = "";
            }
            return data;
          });
          if (
            props.type == "new" &&
            response.data.data[0].yearId != props.yearId
          ) {
            const dataNew = [...dataView];
            setPowerbiData([dataNew[0]]);
          } else {
            setPowerbiData(dataView);
          }
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getMasterprovince = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/setting-table/masterprovince`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setMasterprovince(response.data);
      })
      .catch(function(error) {
        console.log("/v1/setting-table/masterprovince", error);
      });
  };

  const getBusinesse = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5business`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setBusinesse(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5business", error);
      });
  };

  const getDepartment = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5department`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setDepartment(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5department", error);
      });
  };

  const getLevel = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5level`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setLevel(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5level", error);
      });
  };

  const getMainActivity = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5mainactivity`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setMainActivity(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5mainactivity", error);
      });
  };

  const getMainField = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5mainfield`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setMainField(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5mainfield", error);
      });
  };

  const getSubfield = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5subfield`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSubfield(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5subfield", error);
      });
  };

  const getOccupation = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5occupation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setOccupation(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5occupation", error);
      });
  };

  const getOrganization = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5organization`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setOrganization(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5organization", error);
      });
  };

  const getStandard = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table5/table5standard`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setStandard(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table5/table5standard", error);
      });
  };

  useEffect(() => {
    getBusinesse();
    getDepartment();
    getLevel();
    getMainActivity();
    getStandard();
    getOccupation();
    getOrganization();
    getMasterprovince();

    if (props.tableTabSettingId == 10) {
      getMainField();
      getSubfield();
    }

    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = { ...datas[0] };
    data.notPassFemale = "";
    data.notPassMale = "";
    data.notPassTotal = "";
    data.numberFemale = "";
    data.numberMale = "";
    data.numberTotal = "";
    data.passFemale = "";
    data.passMale = "";
    data.passTotal = "";
    setPowerbiData(datas.concat([data]));
  };

  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  return (
    <Row>
      {props.tableTabSettingId == 5 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5>
              ข้อมูลชุดนี้เป็น Data Master หากต้องการเพิ่มกรุณาเพิ่มที่หน้า
              Upload file
            </h5>
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Department</th>
                  <th scope="col">Province_TH</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={3}> Loading... </td>
                  </tr>
                </tbody>
              ) : departmentList != null && departmentList.length > 0 ? (
                <tbody className="table-middle">
                  {departmentList.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.departmentName}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.provinceId}
                          disabled
                        >
                          {masterprovince != null &&
                            masterprovince.length > 0 &&
                            masterprovince.map((item) => {
                              return (
                                <option value={item.provinceId}>
                                  {item.provinceName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={3}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 6 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col" style={{ minWidth: 200 }}>
                    Department
                  </th>
                  <th scope="col" style={{ minWidth: 300 }}>
                    Standard
                  </th>
                  <th scope="col">Number_Male</th>
                  <th scope="col">Number_Female</th>
                  <th scope="col">Number_Total</th>
                  <th scope="col">Pass_Male</th>
                  <th scope="col">Pass_Female</th>
                  <th scope="col">Pass_Total</th>
                  <th scope="col">Not_Pass_Male</th>
                  <th scope="col">Not_Pass_Female</th>
                  <th scope="col">Not_Pass_Total</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={12}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.departmentId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "departmentId", e.target.value);
                          }}
                          require
                        >
                          {departmentList != null &&
                            departmentList.length > 0 &&
                            departmentList.map((item) => {
                              return (
                                <option value={item.departmentId}>
                                  {item.departmentName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.standardId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "standardId", e.target.value);
                          }}
                          require
                        >
                          {standardList != null &&
                            standardList.length > 0 &&
                            standardList.map((item) => {
                              return (
                                <option value={item.standardId}>
                                  {item.standardCode} - {item.standardName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberMale}
                          disabled={!onEditCurrent}
                          placeholder="numberMale"
                          onChange={(e) => {
                            onSetdata(index, "numberMale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberFemale}
                          disabled={!onEditCurrent}
                          placeholder="numberFemale"
                          onChange={(e) => {
                            onSetdata(index, "numberFemale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberTotal}
                          disabled={!onEditCurrent}
                          placeholder="numberTotal"
                          onChange={(e) => {
                            onSetdata(index, "numberTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passMale}
                          disabled={!onEditCurrent}
                          placeholder="passMale"
                          onChange={(e) => {
                            onSetdata(index, "passMale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passFemale}
                          disabled={!onEditCurrent}
                          placeholder="passFemale"
                          onChange={(e) => {
                            onSetdata(index, "passFemale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passTotal}
                          disabled={!onEditCurrent}
                          placeholder="passTotal"
                          onChange={(e) => {
                            onSetdata(index, "passTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassMale}
                          disabled={!onEditCurrent}
                          placeholder="notPassMale"
                          onChange={(e) => {
                            onSetdata(index, "notPassMale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassFemale}
                          disabled={!onEditCurrent}
                          placeholder="notPassFemale"
                          onChange={(e) => {
                            onSetdata(index, "notPassFemale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassTotal}
                          disabled={!onEditCurrent}
                          placeholder="notPassTotal"
                          onChange={(e) => {
                            onSetdata(index, "notPassTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={12}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 7 ? props.type === "edit" ? (
        <Col md="12" style={{ padding: "15px" }}>
          <h5 style={{ float: "left" }}>
            จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
            แถว เนื่องจากข้อมูลมีจำนวนมากจึงไม่สามารถแสดงได้
          </h5>
        </Col>
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <h3>
            เนื่องจากชุดข้อมูล มีข้อมูลจำนวนมาก กรุณาเพิ่มข้อมูลต่างๆในรูปแบบ
            UPLOAD FILE
          </h3>
        </Col>
      ) : null}

      {props.tableTabSettingId == 8 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Department</th>
                  <th scope="col">Main_Activity</th>
                  <th scope="col">Standard</th>
                  <th scope="col">Number_Male</th>
                  <th scope="col">Number_Female</th>
                  <th scope="col">Number_Total</th>
                  <th scope="col">Pass_Male</th>
                  <th scope="col">Pass_Female</th>
                  <th scope="col">Pass_Total</th>
                  <th scope="col">Not_Pass_Male</th>
                  <th scope="col">Not_Pass_Female</th>
                  <th scope="col">Not_Pass_Total</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={14}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.departmentId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "departmentId", e.target.value);
                          }}
                          require
                        >
                          {departmentList != null &&
                            departmentList.length > 0 &&
                            departmentList.map((item) => {
                              return (
                                <option value={item.departmentId}>
                                  {item.departmentName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.mainActivityId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "mainActivityId", e.target.value);
                          }}
                          require
                        >
                          {mainActivityList != null &&
                            mainActivityList.length > 0 &&
                            mainActivityList.map((item) => {
                              return (
                                <option value={item.mainActivityId}>
                                  {item.mainActivityName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.standardId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "standardId", e.target.value);
                          }}
                          require
                        >
                          {standardList != null &&
                            standardList.length > 0 &&
                            standardList.map((item) => {
                              return (
                                <option value={item.standardId}>
                                  {item.standardCode} - {item.standardName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberMale}
                          disabled={!onEditCurrent}
                          placeholder="numberMale"
                          onChange={(e) => {
                            onSetdata(index, "numberMale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberFemale}
                          disabled={!onEditCurrent}
                          placeholder="numberFemale"
                          onChange={(e) => {
                            onSetdata(index, "numberFemale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberTotal}
                          disabled={!onEditCurrent}
                          placeholder="numberTotal"
                          onChange={(e) => {
                            onSetdata(index, "numberTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passMale}
                          disabled={!onEditCurrent}
                          placeholder="passMale"
                          onChange={(e) => {
                            onSetdata(index, "passMale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passFemale}
                          disabled={!onEditCurrent}
                          placeholder="passFemale"
                          onChange={(e) => {
                            onSetdata(index, "passFemale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passTotal}
                          disabled={!onEditCurrent}
                          placeholder="passTotal"
                          onChange={(e) => {
                            onSetdata(index, "passTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassMale}
                          disabled={!onEditCurrent}
                          placeholder="notPassMale"
                          onChange={(e) => {
                            onSetdata(index, "notPassMale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassFemale}
                          disabled={!onEditCurrent}
                          placeholder="notPassFemale"
                          onChange={(e) => {
                            onSetdata(index, "notPassFemale", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassTotal}
                          disabled={!onEditCurrent}
                          placeholder="notPassTotal"
                          onChange={(e) => {
                            onSetdata(index, "notPassTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={14}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 9 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Department</th>
                  <th scope="col">Province</th>
                  <th scope="col">Business_Name</th>
                  <th scope="col">Standard</th>
                  <th scope="col">Number_Total</th>
                  <th scope="col">Pass_Total</th>
                  <th scope="col">Not_Pass_Total</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={10}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.departmentId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "departmentId", e.target.value);
                          }}
                          require
                        >
                          {departmentList != null &&
                            departmentList.length > 0 &&
                            departmentList.map((item) => {
                              return (
                                <option value={item.departmentId}>
                                  {item.departmentName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.provinceId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "provinceId", e.target.value);
                          }}
                          require
                        >
                          {masterprovince != null &&
                            masterprovince.length > 0 &&
                            masterprovince.map((item) => {
                              return (
                                <option value={item.provinceId}>
                                  {item.provinceName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.businessId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "businessId", e.target.value);
                          }}
                          require
                        >
                          {businesseList != null &&
                            businesseList.length > 0 &&
                            businesseList.map((item) => {
                              return (
                                <option value={item.businessId}>
                                  {item.businessName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.standardId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "standardId", e.target.value);
                          }}
                          require
                        >
                          {standardList != null &&
                            standardList.length > 0 &&
                            standardList.map((item) => {
                              return (
                                <option value={item.standardId}>
                                  {item.standardCode} - {item.standardName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberTotal}
                          disabled={!onEditCurrent}
                          placeholder="numberTotal"
                          onChange={(e) => {
                            onSetdata(index, "numberTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passTotal}
                          disabled={!onEditCurrent}
                          placeholder="passTotal"
                          onChange={(e) => {
                            onSetdata(index, "passTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassTotal}
                          disabled={!onEditCurrent}
                          placeholder="notPassTotal"
                          onChange={(e) => {
                            onSetdata(index, "notPassTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={14}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 10 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว
            </h5>

            {props.type === "edit" ? (
              onEditCurrent && (
                <Button
                  theme="success"
                  onClick={() => onAddRowTable()}
                  style={{ float: "right", width: 200 }}
                >
                  เพิ่มแถว
                </Button>
              )
            ) : (
              <Button
                theme="success"
                onClick={() => onAddRowTable()}
                style={{ float: "right", width: 200 }}
              >
                เพิ่มแถว
              </Button>
            )}
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Organization</th>
                  <th scope="col">Main_Field</th>
                  <th scope="col">Sub_Field</th>
                  <th scope="col">Occupation</th>
                  <th scope="col">Level</th>
                  <th scope="col">Number_Total</th>
                  <th scope="col">evaluation_Total</th>
                  <th scope="col">Pass_Total</th>
                  <th scope="col">Not_Pass_Total</th>
                </tr>
              </thead>
              {loading ? (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={10}> Loading... </td>
                  </tr>
                </tbody>
              ) : PowerbiData != null && PowerbiData.length > 0 ? (
                <tbody className="table-middle">
                  {PowerbiData.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.organizationId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "organizationId", e.target.value);
                          }}
                          require
                        >
                          {organizationList != null &&
                            organizationList.length > 0 &&
                            organizationList.map((item) => {
                              return (
                                <option value={item.organizationId}>
                                  {item.organizationName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.mainFieldId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "mainFieldId", e.target.value);
                          }}
                          require
                        >
                          {mainFieldList != null &&
                            mainFieldList.length > 0 &&
                            mainFieldList.map((item) => {
                              return (
                                <option value={item.mainFieldId}>
                                  {item.mainFieldName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.subFieldId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "subFieldId", e.target.value);
                          }}
                          require
                        >
                          {subfieldList != null &&
                            subfieldList.length > 0 &&
                            subfieldList.map((item) => {
                              return (
                                <option value={item.subFieldId}>
                                  {item.subFieldName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.occupationId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "occupationId", e.target.value);
                          }}
                          require
                        >
                          {occupationList != null &&
                            occupationList.length > 0 &&
                            occupationList.map((item) => {
                              return (
                                <option value={item.occupationId}>
                                  {item.occupationName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.levelId}
                          disabled={!onEditCurrent}
                          onChange={(e) => {
                            onSetdata(index, "levelId", e.target.value);
                          }}
                          require
                        >
                          {levelList != null &&
                            levelList.length > 0 &&
                            levelList.map((item) => {
                              return (
                                <option value={item.levelId}>
                                  {item.levelName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.numberTotal}
                          disabled={!onEditCurrent}
                          placeholder="numberTotal"
                          onChange={(e) => {
                            onSetdata(index, "numberTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.evaluationTotal}
                          disabled={!onEditCurrent}
                          placeholder="evaluationTotal"
                          onChange={(e) => {
                            onSetdata(index, "evaluationTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.passTotal}
                          disabled={!onEditCurrent}
                          placeholder="passTotal"
                          onChange={(e) => {
                            onSetdata(index, "passTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                      <td>
                        <FormInput
                          type="number"
                          value={item.notPassTotal}
                          disabled={!onEditCurrent}
                          placeholder="notPassTotal"
                          onChange={(e) => {
                            onSetdata(index, "notPassTotal", e.target.value);
                          }}
                          require
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="table-middle">
                  <tr>
                    <td colSpan={14}> ไม่มีข้อมูล </td>
                  </tr>
                </tbody>
              )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabMaster ? null : props.type === "edit" ? (
        props.tableTabSettingId == 7 ? (
          <Col md="12" style={{ padding: "15px" }}>
            {props.status == 0 && props.userType != 3 ? (
              <>
                {importPath != null && (
                  <a href={importPath} download>
                    <Button theme="warning" style={{ float: "left" }}>
                      ดาวน์โหลดไฟล์ข้อมูลที่ใช้นำเข้า
                    </Button>
                  </a>
                )}

                <Button
                  theme="success"
                  onClick={() => props.onApproveTable()}
                  style={{ float: "right", width: 200 }}
                >
                  อนุมัติเผยแพร่
                </Button>
              </>
            ) : null}
          </Col>
        ) : (
          <Col md="12" style={{ padding: "15px" }}>
            {onEditCurrent ? (
              <Button
                theme="success"
                onClick={() => onCeateTable()}
                style={{ float: "right", width: 200 }}
              >
                บันทึกข้อมูล
              </Button>
            ) : props.status == 0 && props.userType != 3 ? (
              <Button
                theme="success"
                onClick={() => props.onApproveTable()}
                style={{ float: "right", width: 200 }}
              >
                อนุมัติเผยแพร่
              </Button>
            ) : null}
            {!onEditCurrent && (
              <Button
                outline
                theme="secondary"
                onClick={() => setOnEditCurrent(true)}
                style={{ float: "right", width: 200, marginRight: 20 }}
              >
                แก้ไขข้อมูล
              </Button>
            )}
          </Col>
        )
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <Button
            theme="success"
            onClick={() => onCeateTable()}
            style={{ float: "right", width: 200 }}
          >
            บันทึกข้อมูล
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default Table5;
